import React, { useState } from 'react'
import '../CSS/Login.css';

import logo from '../Images/logo.svg'

import { IoEye } from "react-icons/io5";
import { IoEyeOff } from "react-icons/io5";

import Loading from '../Components/Loading';
import Error from '../Components/Error';

import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const navigate = useNavigate();
    const { loginUser } = useAuth();

    const [phone, setPhone] = useState('')
    const [password, setPassword] = useState('');
    const [passwordView, setPasswordView] = useState(false)

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    };

    async function loginAcc() {
        try {
            setLoader(true);

            await loginUser(phone, password);
            navigate('/index/home')
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    return (
        <div className='login'>
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className="login-top">
                <div className="app-logo">
                    <div className="app-logo-img">
                        <img src={logo} alt="" height={'65'} />
                    </div>
                </div>

                <div className="login-tl">
                    <div className="login-tl-top">Welcome Admin,</div>
                </div>
            </div>

            <div className="main-sec">
                <div className="sec-title">Sign In</div> <br />

                <div className="sec-col">
                    <div className="col-title">Phone Number</div>
                    <div className="sec-input">
                        <div className="sec-input-left">+91</div>
                        <input type="text" placeholder='Enter your phone number' value={phone} onChange={(e) => setPhone(e.target.value)} />
                    </div>
                </div>

                <div className="sec-col">
                    <div className="col-title">Password</div>
                    <div className="sec-input">
                        <input type={passwordView === true ? "text" : "password"} placeholder='Enter your password' value={password} onChange={(e) => setPassword(e.target.value)} />
                        <div className="sec-input-right" onClick={() => setPasswordView(!passwordView)}>
                            {passwordView === true ? <IoEyeOff /> : <IoEye />}
                        </div>
                    </div>
                </div>

                <center>
                    <button className="login-btn" onClick={loginAcc}>Login</button>
                </center>
            </div>
        </div>
    )
}

export default Login